import axios from 'axios';

const STORAGE_KEY = 'hub_auth';

export function loadAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveAuth(payload) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function clearAuth() {
  localStorage.removeItem(STORAGE_KEY);
}

const client = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(config => {
  const auth = loadAuth();
  if (auth?.headers) {
    Object.entries(auth.headers).forEach(([k, v]) => {
      config.headers[k] = v;
    });
  }
  if (auth?.accountId && !config.url.startsWith('/hub/api/v1/auth')) {
    config.headers['X-Account-Id'] = auth.accountId;
  }
  return config;
});

client.interceptors.response.use(
  response => {
    const refreshed = {};
    ['access-token', 'client', 'uid', 'expiry', 'token-type'].forEach(key => {
      if (response.headers[key]) refreshed[key] = response.headers[key];
    });
    if (Object.keys(refreshed).length) {
      const current = loadAuth() || {};
      saveAuth({
        ...current,
        headers: { ...(current.headers || {}), ...refreshed },
      });
    }
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      clearAuth();
      const isHubSub = window.location.hostname.startsWith('hub.');
      const loginPath = isHubSub ? '/login' : '/hub/login';
      if (!window.location.pathname.startsWith(loginPath)) {
        window.location.href = loginPath;
      }
    }
    return Promise.reject(error);
  }
);

export default client;
